import { themeBackgroundMap, themeBorderColorMap } from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { BladeCommon, type BladeCommonProps } from '../blade-common.tsx'

export type MediaBladeProps = PropsWithChildren<
  BladeCommonProps & {
    isSelected?: boolean
    isSelectable?: boolean
  }
>
export const MediaBlade = ({
  children,
  className,
  isSelected,
  isSelectable,
  ...props
}: MediaBladeProps) => {
  return (
    <BladeCommon
      className={cn(
        'min-h-[4.5rem] pl-8 py-4 justify-between gap-4',
        isSelectable && 'border-l-4',
        {
          [cn(
            themeBorderColorMap.info,
            themeBackgroundMap['container-tertiary']
          )]: isSelectable && isSelected,
          'border-transparent': isSelectable && !isSelected,
        },
        className
      )}
      {...props}
    >
      {children}
    </BladeCommon>
  )
}
